import { Box, Collapse, Divider, Stack, Typography } from '@mui/material';
import { DocumentTypeCollapseHeader } from './DocumentTypeCollapseHeader';
import { UploadedFileItem, IUploadedFile } from './UploadedFileItem';
import { FileUploadZone } from './FileUploadZone';

export interface IDocumentTypeCollapse {
  subjectName: string;
  isOpen: boolean;
  onDelete: () => void;
  uploadedFiles?: IUploadedFile[];
  onFileSelect: (files: FileList) => void;
  onDeleteFile?: (fileId: string) => void;
  onViewFile?: (fileId: string) => void;
  acceptedFileTypes?: string;
  toggleIsOpen: () => void;
  showDeleteButton: boolean;
  availableDocumentTypesLength: number;
  fileValidationError?: string | null;
}

export const DocumentTypeCollapse = ({
  subjectName,
  isOpen,
  onDelete,
  uploadedFiles = [],
  onFileSelect,
  onDeleteFile,
  onViewFile,
  acceptedFileTypes,
  toggleIsOpen,
  showDeleteButton,
  availableDocumentTypesLength,
  fileValidationError,
}: IDocumentTypeCollapse) => {
  return (
    <Box
      sx={{
        border: '1px solid #E7EDFF',
        borderRadius: '12px',
        backgroundColor: '#FFFFFF',
        overflow: 'hidden',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          boxShadow: '0px 2px 12px rgba(58, 110, 236, 0.15)',
        },
      }}
    >
      {availableDocumentTypesLength > 1 ? (
        <DocumentTypeCollapseHeader
          subjectName={subjectName}
          isOpen={isOpen}
          fileCount={uploadedFiles.length}
          onDelete={onDelete}
          toggleIsOpen={toggleIsOpen}
          showDeleteButton={showDeleteButton}
        />
      ) : (
        <Box sx={{ height: '24px' }} />
      )}

      <Collapse in={isOpen} timeout='auto' unmountOnExit>
        <Box
          sx={{
            padding: '24px',
            pt: '0px',
          }}
        >
          <Stack gap='24px'>
            {fileValidationError && (
              <Typography
                variant='body2'
                sx={{ color: '#ec0000' }}
                role='alert'
              >
                {fileValidationError}
              </Typography>
            )}
            {uploadedFiles.length > 0 && (
              <>
                {uploadedFiles.map((file) => (
                  <UploadedFileItem
                    key={file.id}
                    file={file}
                    onDeleteFile={onDeleteFile}
                    onViewFile={onViewFile}
                  />
                ))}
                <Divider sx={{ borderColor: '#E7EDFF' }} />
              </>
            )}
            <FileUploadZone
              onFileSelect={onFileSelect}
              acceptedFileTypes={acceptedFileTypes}
              hasUploadedFiles={uploadedFiles.length > 0}
            />
          </Stack>
        </Box>
      </Collapse>
    </Box>
  );
};
